'use strict';

var React = require('react');

var SvgDraftOrdersMajor = function SvgDraftOrdersMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.997 1.104a.5.5 0 0 1 .707 0l1.06 1.06a.5.5 0 0 1 0 .707l-.956.957-1.768-1.767.957-.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.333 2.768 1.768 1.768-3.831 3.83a2 2 0 0 1-1.348.585l-.772.025a.25.25 0 0 1-.258-.258l.026-.772a2 2 0 0 1 .584-1.348l3.83-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.976 5a1.25 1.25 0 0 0-1.237 1.067l-.583 3.933h2.484a1.25 1.25 0 0 1 1.185.855l.159.474a.25.25 0 0 0 .237.171h1.558a.25.25 0 0 0 .237-.17l.159-.475a1.25 1.25 0 0 1 1.185-.855h2.484l-.336-2.265a.75.75 0 1 1 1.484-.22l.413 2.792c.063.425.095.853.095 1.282v1.661a3.25 3.25 0 0 1-3.25 3.25h-6.5a3.25 3.25 0 0 1-3.25-3.25v-1.66c0-.43.032-.858.094-1.283l.661-4.46a2.75 2.75 0 0 1 2.72-2.347h3.775a.75.75 0 0 1 0 1.5h-3.774Zm-1.976 6.59v-.09h2.46l.1.303a1.75 1.75 0 0 0 1.66 1.197h1.56a1.75 1.75 0 0 0 1.66-1.197l.1-.303h2.46v1.75a1.75 1.75 0 0 1-1.75 1.75h-6.5a1.75 1.75 0 0 1-1.75-1.75v-1.66Z"
  }));
};
SvgDraftOrdersMajor.displayName = "DraftOrdersMajor";

exports.SvgDraftOrdersMajor = SvgDraftOrdersMajor;
